import { createContext, ReactNode, useContext, useMemo, useState } from 'react'

type BrandRefreshBetaMarketingThemeContextValue = {
  isActive: boolean
  setIsActive: (active: boolean) => void
}

const BrandRefreshBetaMarketingThemeContext = createContext<BrandRefreshBetaMarketingThemeContextValue>({
  isActive: false,
  setIsActive: () => {},
})

export const BrandRefreshBetaMarketingThemeProvider = ({ children }: { children: ReactNode }) => {
  const [isActive, setIsActive] = useState(false)
  const value = useMemo(
    () => ({ isActive, setIsActive }),
    [isActive],
  )

  return (
    <BrandRefreshBetaMarketingThemeContext.Provider value={value}>
      {children}
    </BrandRefreshBetaMarketingThemeContext.Provider>
  )
}

/** True while the early-access banner or its modals are mounted and visible. */
export function useBrandRefreshBetaMarketingThemeControl() {
  return useContext(BrandRefreshBetaMarketingThemeContext)
}
